import * as React from 'react'
import { useCallback } from 'react'
import { useQueryClient } from 'react-query'
import {
  DateRangeFilter,
  Divider,
  IOption,
  MultiSelectFilter,
  TernaryFilter,
} from '@user/components/Filters'
import { IFilterMode } from '@user/components/Filters/typings/IFilterMode'
import { PostalCodeProvider } from './PostalCodeProvider'
import { SubmittedByProvider } from './SubmittedByProvider'
import { BranchProvider } from './BranchProvider'
import { LeadTypeProvider } from '@user/components/Leads/LeadFilters'
import { useTranslation } from 'react-i18next'
import { ImportNameProvider } from './ImportNameProvider'
import { KnockStatusFilter } from '@user/components/Filters/components/KnockStatusFilter'
import { MultiSelectTidalFilter } from '@user/components/Filters/components/MultiSelectFilter'
import { useKnockStatusFilterEnabled } from '@user/store/tenantFeatures/hooks/useKnockStatusFilterEnabled'

export const DraftLeadFilters: React.FC<IFilterMode> = (props) => {
  const client = useQueryClient()
  const { t } = useTranslation()
  React.useEffect(() => {
    client.removeQueries(['filters', 'draftLeads'])
    client.removeQueries(['filters', 'shared'])
  }, [client])

  const { reset } = props
  const knockStatusFilterEnabled = useKnockStatusFilterEnabled()

  const isOptionEqual = useCallback(
    (optionA: IOption, optionB: IOption) => optionA.value === optionB.value,
    [],
  )

  return (
    <>
      <DateRangeFilter
        name="createdTime"
        label="Date Submitted"
        disableFuture
        reset={reset}
      />

      <Divider />

      <MultiSelectFilter
        name="userName"
        label="Submitted By"
        component={SubmittedByProvider}
        reset={reset}
      />

      <MultiSelectFilter
        name="branchId"
        label="Branch"
        component={BranchProvider}
        reset={reset}
      />

      <Divider />

      <TernaryFilter
        name="hasPestPacLocation"
        label="Has PestPac Location"
        trueLabel="Yes"
        falseLabel="No"
        emptyLabel="All"
        reset={reset}
      />

      <Divider />

      <MultiSelectFilter
        name="postalCode"
        label={t('postalCode')}
        component={PostalCodeProvider}
        reset={reset}
      />

      <Divider />

      <MultiSelectFilter
        name="type"
        label="Type"
        component={LeadTypeProvider}
        reset={reset}
      />

      <Divider />

      <MultiSelectFilter
        name="importId"
        label="Import Name"
        component={ImportNameProvider}
        reset={reset}
      />

      {knockStatusFilterEnabled && (
        <>
          <Divider />

          <MultiSelectTidalFilter
            name="knockStatusSettingId"
            label="Knock Status"
            component={KnockStatusFilter}
            reset={reset}
            hideCheckBox={false}
            isOptionEqual={isOptionEqual}
          />
        </>
      )}
    </>
  )
}

DraftLeadFilters.displayName = 'DraftLeadFilters'
